import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PositionsGroupContextMenuComponent } from './positions-group-context-menu.component';
import { ContextMenuModule } from 'ngx-contextmenu';

@NgModule({
  declarations: [PositionsGroupContextMenuComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ContextMenuModule,
  ],
  exports: [PositionsGroupContextMenuComponent]
})
export class PositionsGroupContextMenuModule { }
